<template>
  <el-drawer
    title=""
    :visible.sync="visibleDialog"
    :with-header="false"
    :size="drawerSize"
    direction="ltr"
    custom-class="relic-filter-drawer"
  >
    <el-select
      v-model="relic"
      filterable
      remote
      placeholder="搜索文物名称/编号"
      :remote-method="handleSearchRelic"
      @change="handleChangeRelic"
      ref="searchSelect"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="`${item.number || ''}  ${item.name}` || ''"
        :value="item"
      >
      </el-option>
    </el-select>
    <div class="ctrl">
      <el-switch
        style="display: block"
        v-model="visiblePoint"
        active-color="rgba(152, 83, 66)"
        active-text="数字化展示"
      >
      </el-switch>
      <div class="ctrl-checked">
        <div>建筑筛选</div>
        <el-checkbox-group text-color="red" fill="red" v-model="checkList">
          <el-checkbox
            v-for="item in checkOption"
            :label="item.value"
            :key="item.value"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div @click="handleClearOptions" class="ctrl-clear pointer">清空</div>
    </div>
  </el-drawer>
</template>

<script>
import { mixinModel } from '../assets/js/model';
export default {
  mixins: [mixinModel],
  props: {
    relicList: {
      type: Array,
      default: () => []
    },
    drawerSize: {
      type: String,
      default: '380px'
    }
  },
  computed: {
    visibleDialog: {
      get() {
        return this.modelValue === 2 ? true : false;
      },
      set(list) {
        if (!list) {
          this.modelValue = 7;
        }
      }
    }
  },
  watch: {
    checkList: {
      deep: true,
      handler(newValue) {
        this.$emit('onTypeSelect', newValue);
      }
    },
    visiblePoint(newValue) {
      this.$emit('onChangeVisiblePoint', newValue);
    }
  },
  data() {
    return {
      loading: false,
      checkOption: [
        {
          label: '历史建筑',
          value: 'building'
        },
        {
          label: '文物',
          value: 'relic'
        },
        {
          label: '历史建筑线索',
          value: 'clew'
        }
      ],
      checkList: [],
      relic: '',
      visiblePoint: false,
      options: []
    };
  },
  methods: {
    handleSearchRelic(query) {
      if (query) {
        this.options = this.relicList.filter(item => {
          const count = item.name.toLowerCase().indexOf(query.toLowerCase());
          const test =
            item.number?.toLowerCase().indexOf(query.toLowerCase()) || -1;
          return count + test > -2;
        });
      }
    },

    /**
     * 搜索回调
     */
    handleChangeRelic(value) {
      this.modelValue = 7;
      this.$emit('onSearchRelic', value);
      this.options = [];
    },

    /**
     * 清空回调
     */
    handleClearOptions() {
      this.checkList = [];
      this.visiblePoint = false;
    }
  }
};
</script>

<style lang="scss">
.relic-filter-drawer {
  padding: 20px 20px;
  .el-select {
    .el-input.is-focus {
      .el-input__inner {
        border-color: $primary-light;
      }
    }
    .el-input__inner {
      width: 300px;
      max-width: 70vw;
    }
  }
  .el-switch {
    margin-top: 30px;
    &__label {
      & * {
        font-size: 16px !important;
      }
    }
    &__label.is-active {
      color: $primary;
    }
  }
  .ctrl-checked {
    margin-top: 30px;
  }
  .el-checkbox {
    margin-top: 25px;
    &-group {
      display: flex;
      flex-direction: column;
      margin-left: 20px;
    }
    &__label {
      font-size: 16px;
    }
    .is-checked {
      .el-checkbox__inner {
        background-color: $primary;
        border-color: $primary;
        color: $primary;
      }
      & + .el-checkbox__label {
        color: $primary;
      }
    }
  }
  .ctrl-clear {
    margin-top: 15px;
    text-align: right;
  }
}
.el-select-dropdown__item.selected {
  color: $primary !important;
  font-weight: 700;
}
</style>
